export enum SectionIdEnum {
  Car = 'CAR',
  CarUsage = 'CAR_USAGE',
  Driver = 'DRIVER',
}
